import { Component, OnInit } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { LoadService } from '../../services/load.service';
import { StockService } from '../../services/stock.service';
import { ProductsService } from '../../services/products.service';

import * as moment from 'moment';


import { DatePipe } from '@angular/common';
import { TagsService } from '../../services/tags.service';

@Component({
  selector: 'app-unionsaldo',
  templateUrl: './unionsaldo.component.html',
  styleUrls: ['./unionsaldo.component.css']
})
export class UnionsaldoComponent implements OnInit {
public load:number;
public alert:string;
public isopen:boolean;
public signupFormBuscar:FormGroup;
public buscarcaja: any[];
public cajas:any[];
/*datos para crear código QR*/
public myAngularxQrCode: string;
public prefijo:number;
public idcaja:number;
public valorproducto:string;
public presentacion:string;
public calibre:string;
public fechaElaboracion:Date;
public valorlote:string;
public valorproduccion:string;
public peso:number;
public cliente:string;
public fechaVencimiento:Date;
/*id de producto para obtener calibre y presentación del producto*/
public idproducto:string;
public idproductobusqueda:string;
public idcajaprincipal:string;
public nuevaCaja;
public limitePeso:number;
public signupForm: FormGroup;
public bloquear:boolean;

public errorPeso:boolean;
public errorProducto:boolean;
public cajaIncompleta:boolean;


  constructor(private _loaddata: LoadService, private _stockService:StockService,private datePipe: DatePipe,private _tagsService:TagsService, private _productsService:ProductsService) {
    this.isopen = false;
    this.alert = "";
    this.buscarcaja = [];
    this.cajas = [];
    /*inicialización de datos para código QR*/
    this.myAngularxQrCode = ' ';
    this.prefijo = 1;
    this.idcaja = 1;
    this.valorproducto = '';
    this.idproducto = '';
    this.idproductobusqueda = '';
    this.presentacion = '';
    this.calibre = '';
    this.fechaElaboracion = null;
    this.valorlote = '';
    this.valorproduccion = '';
    this.peso = 0;
    this.cliente = '';
    this.fechaVencimiento = null;
    this.idcajaprincipal = '';
    this.bloquear = false;
    this.limitePeso = 0;
    this.errorPeso = false;
    this.errorProducto = false;
    this.cajaIncompleta = false;

    this.nuevaCaja = {'id':'',
                      'prefijo':'',
                      'producto':'',
                      'lote':'',
                      'ordenproduccion':'',
                      'fechaelaboracion':'',
                      'fechavencimiento':'',
                      'qr':'',
                      'saldo': '0'
                    };
   }

  ngOnInit() {

    this.signupFormBuscar = new FormGroup({
      'busqueda': new FormControl("",Validators.required),
    });

    /*obteniendo un prefijo*/
    this.loadPrefix(true);
    //console.log("PREFIJO: ",this.prefijo);
    this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+')'+this.cliente;

  }

  onSearch(){
    let qr = this.signupFormBuscar.get('busqueda').value;
    /*console.log("Código QR: ", qr);*/

    if(qr != null && qr != ''){
      this.buscarcaja = [];
      this.alert = "Realizando busqueda.";
      this.isopen = true;
      this._loaddata.loadChange(20);
      let variable = '';
      let guion = 0;
      let prefijopallet = '';
      let sufijocaja = '';
      let prefijo = 0;
      let sufijo = 0;

      /*Derrepente la pistola lee 3 caracteres raros*/
      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      /*P18-0000-131-*/
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      if(regexp.test(qr)){
        //console.log("Ha ingresado un código de pallet");
      }
      else{
        for(let char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            prefijo = parseInt(variable);
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = parseInt(variable);
            variable = '';
            guion = 2;
          }
        }

        this.signupFormBuscar.reset();
        this.signupFormBuscar.patchValue({
          'busqueda': ''
        });

        if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
          this._stockService.getOneSaldoStock(prefijo.toString(),sufijo.toString()).subscribe(
            (response:any) => {


              //console.log("Caja Buscada: ", response);
              /*verifico si el tipo de caja corresponse a saldo*/
              if( parseInt(response.relationships.tag.data.relationships.box_type.data.id) != 1){
                      if(this.cajas.length == 0){
                        this.limitePeso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
                        //this.limitePeso = parseInt(response.relationships.tag.data.attributes.weight);
                        //console.log("LIMITE DE PESO: ", this.limitePeso);
                      }
                      let peso = 0;
                      let packing = 'Sin información.';
                      let qr = 'Sin información';
                      let cliente = 'Sin información';
                      let ordenproduccion = 'Sin información';
                      let idorden = 1;

                      if(response.relationships.tag.data.attributes.code != null && response.relationships.tag.data.attributes.code != ''){
                        qr = response.relationships.tag.data.attributes.code;
                      }

                      if(response.relationships.tag.data.relationships.packing.data != null){
                        packing = response.relationships.tag.data.relationships.packing.data.id;
                      }

                      if(response.relationships.tag.data.relationships.production_order.data != null){
                        cliente = response.relationships.tag.data.relationships.production_order.data.attributes.client;
                        ordenproduccion = response.relationships.tag.data.relationships.production_order.data.attributes.number;
                        idorden = parseInt(response.relationships.tag.data.relationships.production_order.data.id);
                      }

                      if(parseInt(response.relationships.tag.data.attributes.residue) != 0){
                        peso = parseInt(response.relationships.tag.data.attributes.residue);
                      }
                      else{
                        peso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
                      }

                      this.idproductobusqueda = response.relationships.tag.data.relationships.product.data.id;
                      //console.log("ID PRODUCTO: ", this.idproductobusqueda);
                      /*creo un objeto caja para el array de cajas*/
                      let caja = {'id':parseInt(response.attributes.tag_id),
                      'peso':peso,
                      'estadotag':response.relationships.tag.data.relationships.tag_status.data.attributes.name,
                      'cliente':cliente,
                      'ordenproduccion':ordenproduccion,
                      'idordenproduccion':idorden,
                      'descripcion':response.relationships.tag.data.relationships.product.data.attributes.description,
                      'grupo':response.relationships.tag.data.relationships.product.data.attributes.group,
                      'producto':response.relationships.tag.data.relationships.product.data.attributes.code,
                      'idproducto':parseInt(response.relationships.tag.data.relationships.product.data.id),
                      'packing':packing,
                      'lote':response.relationships.tag.data.relationships.lot.data.attributes.code,
                      'idlote':parseInt(response.relationships.tag.data.relationships.lot.data.id),
                      'tipotag':response.relationships.tag.data.relationships.box_type.data.name,
                      'estadostock':response.relationships.status.data.attributes.name,
                      'cantidad':response.relationships.pallet.data.attributes.amount,
                      'pallet':response.relationships.pallet.data.attributes.number,
                      'observacion':response.attributes.observation,
                      'elaboracion':response.relationships.tag.data.attributes.elaboration_date,
                      'vencimiento':response.relationships.tag.data.attributes.expiration_date,
                      'qr':qr,
                      'sufijo':response.relationships.tag.data.attributes.suffix,
                      'prefijo':response.relationships.tag.data.attributes.prefix,
                      'posicion':response.relationships.position.data.attributes.name
                    };

                      //this.cajas.push(caja);
                      /*actualizando etiqueta QR*/
                      this.updateEtiquet(caja);
                      //console.log("Array de cajas: ", this.cajas);
                      this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                      this.isopen = true;
                      this._loaddata.loadChange(100);
                      this.onClosedAutomatic();
              }
              else{
                /*La caja buscada no corresponde a una caja de saldo*/
                //console.log("NO CORRESPONDE A UNA CAJA DE SALDO", response);
                this.alert = 'Caja '+prefijo+'-'+sufijo+' No corresponde a una caja de saldo.';
                this.isopen = true;
                this._loaddata.loadChange(100);
                this.onClosedAutomatic();
              }

            },
            (error) => {
              this.alert = 'Caja no encontrada en el sistema.';
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.onClosedAutomatic();
            }
          );
        }
        else{
          this.alert = "Codigo QR invalido.";
          this.isopen = true;
          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
        }
      }
    }
  }

  /*quitar una caja del array cajas*/
  deleteCajaMov(pos:number){
    //console.log("posicion: ", pos);
    let cajaEliminar = this.cajas[pos];
    /*eliminando la caja segun la posicion en el array de cajas*/
    this.cajas.splice(pos,1);
    if(this.cajas.length == 0){
      /*resetear etiqueta y valores*/
      //console.log("No hay cajas en el array de cajas");
      this.resetearEtiqueta();
      //console.log("Limite de peso al eliminar: ", this.limitePeso);
    }
    else{
      /*verificar si los datos corresponden a los de la etiqueta actual (si se esta quitando la caja principal)*/
      if(cajaEliminar.elaboracion === this.fechaElaboracion && cajaEliminar.lote === this.valorlote && cajaEliminar.id === this.idcajaprincipal){
        //console.log("Si entro");
        /*debo buscar la fecha de elaboración más antigua de las cajas que quedan y actualizar los datos*/
        let cajaPrincipal = this.cajas[0];//tomo la primera caja del array para comparar las fechas de las cajas que quedan
        for(let caja of this.cajas){
          if(caja.id == cajaPrincipal.id){
            /*es la misma caja asi que no necesita comparar las fechas*/
          }
          else{
            /*comparando las fechas*/
             let res = this.compararFechas(caja.elaboracion,cajaPrincipal.elaboracion);
             if(res == -1){
                 /*la fecha de elaboración de la caja que se intenta agregar es menor a la fecha de elaboración actual*/
                 cajaPrincipal = caja;

             }
          }
        }

        /*actualizar los datos de etiqueta y caja principal*/
        this.idcajaprincipal = cajaPrincipal.id;
        this.fechaElaboracion = cajaPrincipal.elaboracion;
        this.fechaVencimiento = cajaPrincipal.vencimiento;
        this.valorlote = cajaPrincipal.lote;
        this.valorproduccion = cajaPrincipal.ordenproduccion;
        this.cliente = cajaPrincipal.cliente;
        this.sumarPesos();
        /*actualizando el código QR*/
        //console.log("PESO:", this.peso);
        this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+'Kg)-'+this.cliente

      }
      else{
        /*no se ha eliminado aún la caja principal que contiene los datos de la etiqueta se debe actualizar el peso*/
        this.sumarPesos();
        this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+'Kg)-'+this.cliente
      }
    }
    //console.log("ARRAY DE CAJAS DELETE: ", this.cajas);
  }

  buscarProducto(id:number){

    this._loaddata.loadChange(60);
    this._productsService.getOne(id).subscribe(
      (response:any) => {
        //this.producto = response;
         this.presentacion = response.relationships.properties.data[7].attributes.name+'-'+response.relationships.properties.data[8].attributes.name+'-'+response.relationships.properties.data[11].attributes.name;
         this.calibre = response.relationships.properties.data[10].attributes.name;
         this._loaddata.loadChange(100);
         this.alert = "Carga correcta de características del producto."
         this.onClosedAutomatic();
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  /*Actualizar Etiqueta con los datos*/
  updateEtiquet(caja:any){

    //console.log("Caja Buscada o pistoleada: ", caja);
    if(this.cajas.length == 0){
      /*no existe nada en el arreglo cajas*/
      this.buscarProducto(parseInt(this.idproductobusqueda));
      this.idcajaprincipal = caja.id;
      this.valorproducto = caja.producto;
      this.fechaElaboracion = caja.elaboracion;
      this.fechaVencimiento = caja.vencimiento;
      this.valorlote = caja.lote;
      this.valorproduccion = caja.ordenproduccion;
      this.peso = caja.peso;
      this.cliente = caja.cliente;
      this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+'Kg)-'+this.cliente
      //console.log("PRIMERA CAJA A AGREGAR: ", caja);

      this.cajas.push(caja);

    }
    else{
      /*formato en el que se debe guardar el qr*/
      /*el qr de la etiqueta nueva debe de ser del mismo formato que el código qr*/
      let existe = false;
      let mismoproducto = false;
      let peso = 0;

      for(let item of this.cajas){
        if(item.id === caja.id){
          /*la caja ya esta en el array de cajas*/
          existe = true;
        }
        if(item.producto === caja.producto){
          /*la caja que se intenta agregar tiene el mismo producto que las cajas del array*/
          mismoproducto = true;
        }
        /*sumo los kilos del array*/
        peso = parseInt(item.peso) + peso;
      }


      peso = parseInt(caja.peso)+peso;
      //console.log("CONDICIONES: ", existe, mismoproducto, peso);
      /*pregunto si el producto no existe, y si el producto es el mismo producto y el peso no excede el máximo permitido*/
      //  restriccion de peso (&& peso <= 10)

      if(existe == false && mismoproducto == true && peso <= this.limitePeso){
        /*si cumple las condiciones lo puedo agregar al array de cajas*/
        this.peso = peso;
        let res = this.compararFechas(caja.elaboracion, this.fechaElaboracion);
        //console.log("RESPUESTA: ", res);
        /*comparo si la fecha de elaboración de la caja nueva  es anterior a la fecha de elaboracion actual */
        if(res == 1 || res == 0){
          /*solo se debe agregar la caja al array de cajas ya que se conserva la información*/
          this.cajas.push(caja);
          this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+'Kg)-'+this.cliente
        }
        else if(res == -1){
             /*la fecha de elaboración de la caja que se intenta agregar es menor a la fecha de elaboración actual*/
             //console.log("DATOS CAJA: ", caja);
             this.idcajaprincipal = caja.id;
             this.fechaElaboracion = caja.elaboracion;
             this.fechaVencimiento = caja.vencimiento;
             this.valorlote = caja.lote;
             this.valorproduccion = caja.ordenproduccion;
             this.cliente = caja.cliente;
             /*actualizando el código QR*/
             this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+'Kg)-'+this.cliente
             this.cajas.push(caja);
        }

      }
      else{
          if(!mismoproducto){
            this.errorProducto = true;
          }
          else{
            if(peso > this.limitePeso){
              this.errorPeso = true;

              setTimeout(()=>{
                this.eliminarAlert();
              }, 10000);
            }
            //console.log("No se cumplieron las condiciones de producto y peso");
          }

      }


      /*debo conservar la fecha mas antigua y lote asociado, si hay mas de una caja debo sumar los saldos, si selecciono una caja esta trae un
      producto asociado entonces debo comparar que en el arreglo cajas solo existan cajas con el mismo producto para poder unir saldos*/

    }
    //console.log("ARRAY DE CAJAS UPDATE: ", this.cajas);
  }

/*inicialización de prefijo (etiqueta)*/
  loadPrefix(op:boolean){
    let alert = this.alert;
    this.alert = "Calculando prefijo.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    this._tagsService.getPrefix().subscribe(
      (response:any) => {
        //console.log("Respuesta Prefijo: ", response);
        if(response.data.length == 0){
          //console.log("entro aqui");
          this.prefijo = 1;
          this.alert = alert+". Prefijo "+this.prefijo+" disponible."

          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
        }
        else{

          this.prefijo = 1 + parseInt(response.data[0].attributes.prefix);

          this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+')'+this.cliente;
          this.alert = alert+" Prefijo "+this.prefijo+" disponible."

          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
        }
        this._loaddata.loadChange(100);
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
    this.onClosedAutomatic();
  }

  /**
   * Cierra el mensaje de alerta.
   */
    onClosed(): void {
      this.isopen = false;
    }

    /**
    * Cierra el mensaje de alerta despues de 5 segundos
    */
    onClosedAutomatic(): void {

        setTimeout(()=>{
        this.isopen = false;
      }, 5000);

    }
    /*fecha de la caja que se quiere agregar (dateTimeA), fecha actual de la etiqueta(dateTimeB)*/
    compararFechas(dateTimeA, dateTimeB) {

    dateTimeA = this.datePipe.transform(dateTimeA, 'dd/MM/yyyy');
    dateTimeB = this.datePipe.transform(dateTimeB, 'dd/MM/yyyy')
    let momentA = moment(dateTimeA,"DD/MM/YYYY");
    let momentB = moment(dateTimeB,"DD/MM/YYYY");

    //console.log("Fecha A: ", momentA);
    //console.log("Fecha B: ", momentB);
    if (momentA > momentB) return 1;
    else if (momentA < momentB) return -1;
    /*si retorna 0 es porque las fechas son iguales*/
    else return 0;
}

onSubmit(){
  if(this.cajas.length != 0 && this.peso == this.limitePeso){
    let cajaPrincipal;
    for(let caja of this.cajas){
      if(caja.id == this.idcajaprincipal){
        cajaPrincipal = caja;
      }
    }

    this.nuevaCaja = {'id':cajaPrincipal.id,
                      'prefijo':this.prefijo,
                      'sufijo':this.idcaja,
                      'producto':cajaPrincipal.idproducto,
                      'lote':cajaPrincipal.idlote,
                      'ordenproduccion':cajaPrincipal.idordenproduccion,
                      'fechaelaboracion':this.fechaElaboracion,
                      'fechavencimiento':this.fechaVencimiento,
                      'qr':this.myAngularxQrCode,
                      'saldo': '0'
                    };
    //console.log("Caja Principal: ", cajaPrincipal);
    //console.log("CAJA NUEVA: ", this.nuevaCaja);

    let data = this._tagsService.transformDataUnionSaldo(this.nuevaCaja);
    //console.log("JSON A ENVIAR: ",data);
    this._tagsService.save(data).subscribe(
      response =>{
        //console.log("Respuesta: ", response);
        let idUnionSaldo = response['id'];
        this.actualizarTags(idUnionSaldo);


    },
    (error) => {
      //console.log("Error: ",error);
      this.showError(error.error.error);
      this.loadPrefix(false);
    });
  }
  else{
    if(this.cajas.length != 0){

      this.cajaIncompleta = true;
      setTimeout(()=>{
        this.cajaIncompleta = false;
      }, 10000);
    }
  }
}

/*recibe el id nuevo de la etiqueta que se generó a partir de los saldos unidos y envia los datos al backend*/
actualizarTags(idUnionSaldo:string){
  //console.log("ID Nueva: ", idUnionSaldo);
  let body = this._tagsService.transformDataTagsUnionSaldo(this.cajas,idUnionSaldo);
  /*enviado las cajas a actualizar*/
  this._tagsService.update(body).subscribe(response =>{
    //console.log("CAJAS ACTUALIZADAS: ", response);
    this.print();
    this.resetearEtiqueta();
    this._loaddata.loadChange(100);
    this.alert = "Etiqueta Creada.";
    this.isopen =true;
    this.onClosedAutomatic();
  }, error =>{
    //console.log("Algo Ha salido mal: ", error);
  })
}

/**
 * Abre una nueva ventana para imprimir las etiquetas QR contenidas
 * en printContents, que a su vez esta relacionado con print-section del html.
 */
  private print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style></style>
        </head>
        <body onload="window.print();window.close()">
          ${printContents}
        </body>
      </html>`
    );
    popupWin.document.close();
  }

  /*sumar pesos*/

  sumarPesos(){
    let peso = 0;
    for(let caja of this.cajas){
      peso = peso + parseInt(caja.peso);
    }
    this.peso = peso;
  }

  /*resetear campos y etiqueta*/
  resetearEtiqueta(){
    this.isopen = false;
    this.alert = "";
    this.buscarcaja = [];
    this.cajas = [];
    /*inicialización de datos para código QR*/
    // this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.signupForm.value.valorproducto+'-'+this.datePipe.transform(this.signupForm.value.elaboracion, 'dd/MM/yyyy')+'-'+this.signupForm.value.valorlote+'-'+this.signupForm.value.valorproduccion+'-PESO('+this.signupForm.value.peso+'Kg)-'+this.signupForm.value.cliente
    this.myAngularxQrCode = ' ';
    this.prefijo = 1;
    this.idcaja = 1;
    this.valorproducto = '';
    this.idproducto = '';
    this.idproductobusqueda = '';
    this.presentacion = '';
    this.calibre = '';
    this.fechaElaboracion = null;
    this.valorlote = '';
    this.valorproduccion = '';
    this.peso = 0;
    this.cliente = '';
    this.fechaVencimiento = null;
    this.idcajaprincipal = '';
    this.bloquear = false;
    this.limitePeso = 0;

    this.errorPeso = false;
    this.errorProducto = false;
    this.cajaIncompleta = false;

    this.nuevaCaja = {'id':'',
                      'prefijo':'',
                      'producto':'',
                      'lote':'',
                      'ordenproduccion':'',
                      'fechaelaboracion':'',
                      'fechavencimiento':'',
                      'qr':'',
                      'saldo': '0'
                    };

    /*obteniendo un prefijo*/
    this.loadPrefix(false);
    /*seteando el código QR*/
    this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.valorproducto+'-'+this.datePipe.transform(this.fechaElaboracion, 'dd/MM/yyyy')+'-'+this.valorlote+'-'+this.valorproduccion+'-PESO('+this.peso+')'+this.cliente;

  }

  eliminarAlert(){
   this.errorPeso = false;
  }

  eliminarAlert2(){
   this.cajaIncompleta = false;
  }

  eliminarAlert3(){
   this.errorProducto = false;
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/unionsaldo/unionsaldo.component.ts